const Crayola = require('crayola-colors');

// Place to bootstrap new colours
Crayola["Bluetiful"] = "3F6DE4";

const PACKS = {
    "52-3024": [
        Crayola["Brown"], Crayola["Violet Red"], Crayola["Red"], Crayola["Scarlet"],
        Crayola["Red Orange"], Crayola["Orange"], Crayola["Yellow Orange"], Crayola["Apricot"],
        Crayola["Yellow"], Crayola["Green Yellow"], Crayola["Yellow Green"], Crayola["Green"],
        Crayola["Blue Green"], Crayola["Cerulean"], Crayola["Blue"], Crayola["Indigo"],
        Crayola["Bluetiful"], Crayola["Blue Violet"], Crayola["Violet (Purple)"], Crayola["Red Violet"], 
        Crayola["Carnation Pink"], Crayola["White"], Crayola["Gray"], Crayola["Black"], 
    ]
};

module.exports = PACKS;